import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
	theme: {
		options: { customProperties: true },
		themes: {
			light: {
				base: '#e80f02',
				primary: '#d56901',
				secondary: '#8d2d04',
			},
		},
	},
});
